import { isRejectedWithValue } from '@reduxjs/toolkit';
import _get from 'hs-lodash/get';
import captureException from 'in-meeting-experience-ui-components/utils/captureException';
import { isAcceptanceTestOrDev } from 'in-meeting-experience-ui-components/utils/general';
// point if this middleware to catch error during work with data in async thunk actions
// (we catch api error in API client, runtime errors in React error boundary)
const errorThunkMiddleware = _store => next => action => {
  if (isRejectedWithValue(action)) {
    // check if we already sent sentry event in authenticationAlertMiddleware middleware of the api client
    const isSentryEventSent = _get(action, 'payload.responseJSON.sentryEventSent', false);
    if (!isSentryEventSent && !isAcceptanceTestOrDev && action.payload instanceof Error) {
      captureException(action.payload);
    } else if (!isSentryEventSent) {
      console.error(action.payload);
    }
  }
  next(action);
};
export default errorThunkMiddleware;